<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M5.333 4.333c0-.92.746-1.666 1.667-1.666h13v.002l6.664 6.664h.002v18.334c0 .92-.746 1.666-1.666 1.666H7c-.92 0-1.667-.746-1.667-1.666V4.333zM20 7.667v-2.17l3.836 3.836h-2.17c-.92 0-1.666-.746-1.666-1.666zm1.028 9.374a1 1 0 00-1.414-1.415L14.32 20.92l-1.78-1.78a1 1 0 00-1.415 1.414l2.488 2.488a1 1 0 001.414 0l6-6z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'filesCheckFilled'
}
</script>
